import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_ENABLE_PRIDE_LOGO = createFcmDetails('enable_pride_logo', {
	// owner: '',
	context: 'Page header',
	description: 'Replace the default logo with a colorful "pride" logo.',
	import: false,
});
